/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Payments_ManageInputs */

const en_my_payments_manage = /** @type {(inputs: My_Payments_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage`)
};

const pl_my_payments_manage = /** @type {(inputs: My_Payments_ManageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarządzaj`)
};

/**
* | output |
* | --- |
* | "Manage" |
*
* @param {My_Payments_ManageInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_manage = /** @type {((inputs?: My_Payments_ManageInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_ManageInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_manage(inputs)
	return en_my_payments_manage(inputs)
});